export default __webpack_public_path__ + "static/carleaseOverview1-d16f1593e1b2c4053a7a099d932e9e0c.avif";